// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rewardTypeSectionStyles } from "@rc/App/Components/RewardsTypes/RewardTypeSection";
import { fontConfig } from "@rc/XDL/PreStyle/typography";
import { color, xScreen } from "@rc/XDL/Utilities";
import { css } from "styled-components";

rewardTypeSectionStyles.rewardTypeContainer = {
    css: css`
        padding: 4px;
        display: flex;
        justify-content: space-between;
        gap: 8px;
        border: 1px solid ${color("common.border")};
        border-radius: 2px;
        background: ${color("common.ui8")};
    `,
};

rewardTypeSectionStyles.title = {
    size: 14,
    lineHeight: "22px",
    weight: fontConfig.weight.medium,
    css: css`
        ${({ isTitle }: any) => {
            if (isTitle) {
                return css`
                    ${xScreen("gte", "md")} {
                        max-width: 173px;
                    }
                `;
            }
        }}
    `,
};
